import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, MenuItem, Avatar, IconButton, FormHelperText, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import CalenderSVG from "assets/logo/Calendar";
import { useEditDependencyMutation } from "store/slices/apis/customerDependenciesSlice";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const EditDependency = (props) => {
    const { open, handleClose, rowData } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();

    const [updateDependencyFun, updateDependencyRes] = useEditDependencyMutation();

    const [formData, setFormData] = useState({
        dependencyOnSafeExpress: rowData?.dependencyOnSafeExpress,
        status: rowData?.status,
        dueDate: rowData?.dueDate ? moment(rowData?.dueDate)?.format("YYYY-MM-DD") : null,
        receivedDate: rowData?.receivedDate ? moment(rowData?.receivedDate)?.format("YYYY-MM-DD") : null,
        targetDate: rowData?.targetDate ? moment(rowData?.targetDate)?.format("YYYY-MM-DD") : null,
        projectId,
        isActive: true,
        remarks: rowData?.remarks

    });

    const validationSchema = Yup.object({
        dependencyOnSafeExpress: Yup.string().required("Dependency On Safexpress field is required"),
        status: Yup.string().required("Status field is required"),
        // dueDate: Yup.date().required("Due Date field is required"),
        // receivedDate: Yup.date().required("Received Date field is required"),
        // targetDate: Yup.date().required("Target Date field is required"),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        let receivedDate = null, dueDate = null, targetDate = null;

        if (values?.receivedDate) {
            receivedDate = moment
                .utc(values?.receivedDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (values?.dueDate) {
            dueDate = moment
                .utc(values?.dueDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (values?.targetDate) {
            targetDate = moment
                .utc(values?.targetDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        let modifiyValues = {
            ...values, dueDate, receivedDate, targetDate, customerDependenciesId: rowData?.customerDependenciesId
        }
        await updateDependencyFun(modifiyValues)
    };

    React.useEffect(() => {
        if (updateDependencyRes?.isSuccess) {
            if (updateDependencyRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(updateDependencyRes?.data?.message, 'success')
                handleClose();
            } else {
                openNotification(updateDependencyRes?.data?.message, 'error')
            }
        }
    }, [updateDependencyRes?.isSuccess]);


    React.useEffect(() => {
        if (updateDependencyRes?.isError) {
            if (updateDependencyRes?.error?.data?.status?.toLowerCase() == 'fail') {
                openNotification(updateDependencyRes?.error?.data?.message, 'error')
            } else {
                openNotification(updateDependencyRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [updateDependencyRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Edit Customer Dependency
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldTouched,
                        setTouched, }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Dependency On Safexpress</Typography>
                                    <TextField
                                        fullWidth
                                        name="dependencyOnSafeExpress"
                                        value={values.dependencyOnSafeExpress}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Dependency On Safexpress"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.dependencyOnSafeExpress && errors.dependencyOnSafeExpress && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dependencyOnSafeExpress}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Status</Typography>
                                    <TextField
                                        fullWidth
                                        name="status"
                                        value={values?.status}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Status"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.status && errors.status && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.status}
                                        </Typography>
                                    )}
                                </Grid>








                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Due Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dueDate"
                                        value={values.dueDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.dueDate && errors.dueDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dueDate}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Target Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="targetDate"
                                        value={values.targetDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.targetDate && errors.targetDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.targetDate}
                                        </Typography>
                                    )}
                                </Grid>



                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Received Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="receivedDate"
                                        value={values.receivedDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.receivedDate && errors.receivedDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.receivedDate}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Remarks</Typography>
                                    <TextField
                                        fullWidth
                                        name="remarks"
                                        value={values.remarks}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Remarks"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.remarks && errors.remarks && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.remarks}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button onClick={handleClose}
                                            sx={{
                                                textTransform: "none",
                                                color: "#F15744",
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                borderRadius: "25px",
                                                fontWeight: 500,
                                                px: "20px",
                                                py: "15px",
                                            }}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            // loading={isLoading}
                                            sx={{
                                                backgroundColor: "#00344C",
                                                borderRadius: "25px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#FFFFFF",
                                                px: "20px",
                                                py: "15px",
                                                display: "flex",
                                                gap: 1,
                                                "&.Mui-disabled": {
                                                    backgroundColor: "#00344C",
                                                    color: "#fff",
                                                    opacity: 0.7,
                                                },
                                            }}
                                            disabled={updateDependencyRes?.isLoading}
                                        >
                                            {updateDependencyRes?.isLoading && <CircularProgress size={16} color="inherit" />}
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default EditDependency;